﻿export interface IDonorConnectUser {
    id: number,
    firstName: string,
    lastName: string,
    email: string,
    donorConnectCaseLoad: number,
    activeCaseCount: number,
    assignedTodayCount: number,
    currentCaseLoad: number
}
